import { Button, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { MethodButtonStyles } from './styles';

interface MethodButtonProps {
  children: ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  variant?: 'compact' | 'journey';
}

export default function MethodButton({ children, isSelected, onClick, variant = 'compact' }: MethodButtonProps) {
  const theme = useTheme();
  const styles = MethodButtonStyles(theme, isSelected ?? false, variant);
  return (
    <Button variant="text" onClick={onClick} sx={styles.mainContainer}>
      {children}
    </Button>
  );
}
